"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _intlDesignUi = require("@tencent/intl-design-ui");
var _componentUtils = require("../../common/componentUtils");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
var _formatVodData2 = require("../../utils/formatVodData");
var _formatCommodityData = require("../../utils/formatCommodityData");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const formatData = (businessData, type) => {
  const title = businessData.title,
    icon = businessData.icon,
    price = businessData.price,
    _businessData$list = businessData.list,
    list = _businessData$list === void 0 ? [] : _businessData$list,
    _businessData$suggest = businessData.suggest,
    suggest = _businessData$suggest === void 0 ? {} : _businessData$suggest,
    _businessData$href = businessData.href,
    href = _businessData$href === void 0 ? '' : _businessData$href,
    _businessData$commodi = businessData.commodityObject,
    commodityObject = _businessData$commodi === void 0 ? '{}' : _businessData$commodi,
    isLink = businessData.isLink,
    _businessData$buttonT = businessData.buttonText,
    buttonText = _businessData$buttonT === void 0 ? '' : _businessData$buttonT;
  const _formatVodData = (0, _formatVodData2.formatVodData)(icon),
    businessIcon = _formatVodData.url;
  const businessList = list.map((item, index) => {
    const text = item.text;
    return text;
  });
  const subTitle = suggest.subTitle,
    describe = suggest.describe,
    linkText = suggest.linkText,
    linkUrl = suggest.linkUrl;
  var resultSuggest;
  if (subTitle) {
    resultSuggest = {
      subTitle,
      describe,
      link: {
        text: linkText,
        to: linkUrl,
        extendProps: {
          'report-event-goal': 'click_couponOMTwo',
          'report-event': type ? 'click_couponOMTwo_business_href' : 'click_couponOMTwo_person_href',
          'report-ext1': linkText,
          'report-ext2': linkUrl
        }
      }
    };
  } else {
    resultSuggest = null;
  }
  const resultCommodityObject = (0, _formatCommodityData.formatCommodityData)(commodityObject);
  const topData = _objectSpread(_objectSpread({
    title,
    icon: businessIcon,
    price,
    list: businessList,
    isLink
  }, resultCommodityObject), {}, {
    href,
    buttonText,
    extendProps: {
      'report-event-goal': 'click_couponOMTwo',
      'report-event': type ? 'click_click_couponOMTwo_business_button' : 'click_click_couponOMTwo_person_button',
      'report-ext1': buttonText,
      'report-ext2': href
    }
  });
  return {
    topData,
    suggest: resultSuggest,
    onClick: () => {
      window.asyncReceiveCommodity(topData);
    }
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const componentData = data;
  if (componentData) {
    const porintId = data.porintId,
      paddingTopNum = data.paddingTopNum,
      paddingBottomNum = data.paddingBottomNum,
      _data$title = data.title,
      title = _data$title === void 0 ? '' : _data$title,
      _data$desc = data.desc,
      desc = _data$desc === void 0 ? '' : _data$desc,
      _data$color = data.color,
      color = _data$color === void 0 ? '' : _data$color,
      _data$businessData = data.businessData,
      businessData = _data$businessData === void 0 ? {} : _data$businessData,
      _data$personData = data.personData,
      personData = _data$personData === void 0 ? {} : _data$personData;
    const _formatData = formatData(businessData, true),
      topData = _formatData.topData,
      suggest = _formatData.suggest,
      onClick = _formatData.onClick;
    const _formatData2 = formatData(personData, false),
      personTopData = _formatData2.topData,
      personSuggest = _formatData2.suggest,
      personOnClick = _formatData2.onClick;
    const bgStyle = {};
    if (color) {
      bgStyle.background = color;
    }
    const paddingStyle = (0, _componentUtils.doComponentsStyleEvent)({
      paddingTopNum,
      paddingBottomNum
    }); // 处理组件背景色
    paddingStyle.minWidth = 'unset';
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId
    }, (0, _reportUtil.reportShow)(['show_couponOMTwo', componentKey, porintId]), {
      style: bgStyle
    }), /*#__PURE__*/React.createElement(_intlDesignUi.Section, {
      col: 2,
      title: title,
      desc: desc,
      style: paddingStyle
    }, /*#__PURE__*/React.createElement(_intlDesignUi.CouponOMTwo, Object.assign({}, topData, {
      suggest: suggest,
      onClick: onClick
    })), /*#__PURE__*/React.createElement(_intlDesignUi.CouponOMTwo, Object.assign({}, personTopData, {
      suggest: personSuggest,
      onClick: personOnClick
    }))));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
}